@if ( this.storeService.getSposobNadaniaTyp() ===
SposobNadaniaType.ZAMOW_KURIERA &&
this.storeService.getSposobNadaniaStepNumber() === 1 ) {
<form [formGroup]="confirmDataForm" (keydown.enter)="$event.preventDefault()">
  <div>
    <div class="fdx-o-grid fdx-o-grid--max-width">
      <app-page-header [title]="'Dokładnie sprawdź dane'">
        Zatwierdź poprawność wprowadzonych danych oraz wymagane zgody.<br />
        Kliknij DALEJ by zakończyć proces nadania przesyłki lub WSTECZ by
        edytować dane.
      </app-page-header>

      <div class="fdx-o-grid__row fdx-o-grid__row--center">
        <div
          class="fdx-o-grid__item fdx-o-grid__item--7@large fdx-o-grid__item--7@medium fdx-o-grid__item--11">
          <div class="fdx-o-grid__row fdx-o-grid__row--guttered-small">
            <dl
              class="fdx-o-grid__item--6 fdx-c-definitionlist fdx-c-definitionlist--bold">
              @if (this.storeService.getShipNo()) {
              <dt class="fdx-c-definitionlist__title fdx-u-align--left">
                Numer listy przewozowego
              </dt>
              <dd class="fdx-c-definitionlist__description fdx-u-mb--5">
                {{ this.storeService.getShipNo() }}
              </dd>
              }

              <dt class="fdx-c-definitionlist__title">
                Adres nadania przesyłki
              </dt>
              <dd
                class="fdx-c-definitionlist__description fdx-u-word-break--break-all">
                ul.
                {{ this.storeService.getShippingCourierFormData()?.street }}
                {{
                  this.storeService.getShippingCourierFormData()?.houseNumber
                }}
                @if (
                this.storeService.getShippingCourierFormData()?.apartmentNumber
                ) { /
                {{
                  this.storeService.getShippingCourierFormData()
                    ?.apartmentNumber
                }}
                }
              </dd>
              <dd
                class="fdx-c-definitionlist__description fdx-u-word-break--break-all fdx-u-mb--5">
                {{ this.storeService.getShippingCourierFormData()?.zipCode }}
                {{ this.storeService.getShippingCourierFormData()?.city }}
              </dd>

              <dt class="fdx-c-definitionlist__title">Osoba kontaktowa</dt>
              <dd
                class="fdx-c-definitionlist__description fdx-u-word-break--break-all">
                {{ this.storeService.getShippingCourierFormData()?.name }}
              </dd>
            </dl>
            <dl
              class="fdx-o-grid__item--6 fdx-c-definitionlist fdx-c-definitionlist--bold">
              <dt
                class="fdx-c-definitionlist__title fdx-o-grid__row fdx-o-grid__row--end">
                Data odbioru przesyłki
              </dt>
              <dd
                class="fdx-c-definitionlist__description fdx-u-word-break--break-all fdx-u-mb--5 fdx-o-grid__row fdx-o-grid__row--end">
                {{ this.storeService.getShippingCourierFormData()?.date }}
              </dd>

              <dt
                class="fdx-c-definitionlist__title fdx-o-grid__row fdx-o-grid__row--end">
                Godzina odbioru przesyłki
              </dt>
              <dd
                class="fdx-c-definitionlist__description fdx-u-word-break--break-all fdx-u-mb--5 fdx-o-grid__row fdx-o-grid__row--end">
                {{
                  this.storeService.getPickupDateHoursPeriodResponse()
                    ?.pickupHourFrom
                }}
                -
                {{
                  this.storeService.getPickupDateHoursPeriodResponse()
                    ?.pickupHourTo
                }}
              </dd>

              <dt
                class="fdx-c-definitionlist__title fdx-o-grid__row fdx-o-grid__row--end">
                Telefon kontaktowy
              </dt>
              <dd
                class="fdx-c-definitionlist__description fdx-u-word-break--break-all fdx-u-mb--5 fdx-o-grid__row fdx-o-grid__row--end">
                {{ this.storeService.getShippingCourierFormData()?.phone }}
              </dd>

              @if (this.storeService.getShippingCourierFormData()?.instructions)
              {
              <dt
                class="fdx-c-definitionlist__title fdx-o-grid__row fdx-o-grid__row--end">
                Instrukcja do odbioru
              </dt>
              <dd
                class="fdx-c-definitionlist__description fdx-u-word-break--break-all fdx-o-grid__row fdx-o-grid__row--end">
                {{
                  this.storeService.getShippingCourierFormData()?.instructions
                }}
              </dd>
              }
            </dl>
          </div>

          <div
            class="fdx-o-grid__row fdx-o-grid__row--center fdx-u-mb--10 fdx-u-mt--10">
            <!-- <div
                class="fdx-o-grid__item fdx-o-grid__item--12 fdx-o-grid__row--guttered-large">
                <div
                  class="fdx-o-grid__item fdx-o-grid__item--12 fdx-c-form fdx-c-form--checkbox">
                  <label
                    for="_checkbox1-default"
                    class="fdx-c-form__label"
                    style="padding-left: 30px"
                    >{{
                      this.isPayerNoProvided()
                        ? 'SAMODZIELNIE WYDRUKUJĘ ETYKIETĘ'
                        : 'MAM JUŻ ETYKIETĘ'
                    }}</label
                  >
                  <input
                    type="checkbox"
                    name="format"
                    class="fdx-c-form__checkbox"
                    id="_checkbox1-default"
                    formControlName="print_the_label" />
                  <div class="fdx-c-form__indicator"></div>
                </div>
                <app-form-input-control
                  class="fdx-o-grid__item--12"
                  [formField]="emailControl"
                  [labelName]="'E-MAIL DO POTWIERDZENIA ZLECENIA'">
                  <input
                    type="email"
                    class="fdx-c-form-group__input fdx-u-px--4"
                    id="email"
                    formControlName="email" />
                </app-form-input-control>
              </div> -->
            <div class="fdx-o-grid__item fdx-o-grid__item--12">
              <p class="fdx-c-paragraph fdx-c-paragraph--small">
                Jesteśmy Administratorem przekazanych przez Panią/Pana danych
                osobowych i przetwarzamy je w zgodzie z ogólnym rozporządzeniem
                o ochronie danych osobowych RODO oraz na zasadach określonych w
                <a
                  class="fdx-u-color--blue"
                  href="https://www.fedex.com/pl-pl/privacy-policy.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Polityce prywatności</a
                >
                spółek grupy FedEx Corporation.
              </p>
            </div>
            <div
              class="fdx-o-grid__item fdx-o-grid__item--11 fdx-c-form--checkbox fdx-c-form--checkbox-condensed">
              <label
                for="accept_processing_data"
                class="fdx-c-form__label"
                style="padding-left: 30px"
                ><p class="fdx-c-paragraph fdx-c-paragraph--small">
                  Akceptuję
                  <a
                    class="fdx-u-color--blue"
                    href="https://www.fedex.com/pl-pl/terms-of-use.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    >Warunki korzystania</a
                  >
                  ze strony internetowej FedEx,
                  <a
                    class="fdx-u-color--blue"
                    href="https://www.fedex.com/pl-pl/conditions-of-carriage-domestic.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    >Warunki przewozu dla usług krajowych FedEx</a
                  >
                  oraz
                  <a
                    class="fdx-u-color--blue"
                    href="https://www.fedex.com/content/dam/fedex/eu-europe/resources/fedex-europe-service-guide-domestic-pl-pl.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    >Przewodnik po usługach krajowych FedEx</a
                  >.
                </p></label
              >
              <input
                type="checkbox"
                name="format"
                class="fdx-c-form__checkbox"
                id="accept_processing_data"
                formControlName="accept_processing_data" />
              <div class="fdx-c-form__indicator"></div>
            </div>
            <div
              class="fdx-o-grid__item fdx-o-grid__item--11 fdx-c-form--checkbox fdx-c-form--checkbox-condensed">
              <label
                for="confirm_data"
                class="fdx-c-form__label"
                style="padding-left: 30px"
                ><p class="fdx-c-paragraph fdx-c-paragraph--small">
                  Potwierdzam poprawność danych zawartych w formularzu oraz
                  samodzielne wydrukowanie etykiety.
                </p></label
              >
              <input
                type="checkbox"
                name="format"
                class="fdx-c-form__checkbox"
                id="confirm_data"
                formControlName="confirm_data" />
              <div class="fdx-c-form__indicator"></div>
            </div>
          </div>
        </div>
      </div>

      <app-form-error-message
        [submitException]="submitException()"
        [form]="confirmDataForm">
      </app-form-error-message>

      <div
        class="fdx-o-grid__row fdx-o-grid__row--center fdx-o-grid__row--guttered-small">
        <app-back-button
          [isLoading]="false"
          [isDisabled]="isSubmitLoading()"
          [buttonText]="'WSTECZ'"
          (clickEvent)="backButtonAction()">
        </app-back-button>
        <app-submit-button
          [isLoading]="isSubmitLoading()"
          [isDisabled]="confirmDataForm.invalid"
          [buttonText]="'DALEJ'"
          (clickEvent)="onSubmit()"
          style="margin-left: 5px; margin-right: 2.5px">
        </app-submit-button>
      </div>
    </div>
  </div>
</form>
}
